<template>
    <Header v-if="1==2" v-show="randVisible" ueberschrift="Gefahrgut"/>
    <div id="gefahrgut" :class="randVisible ? 'margin' : 'noMargin'">
        <iframe src="https://sync.einsatzleiterwiki.de/doku.php?id=cbrn:ericards:start" :class="randVisible ? 'iframe':'fullscreen'">
        </iframe>

        <button v-if="1==2" id="controlButton" @click="switchMapControl()" class="fa">&#xf013;</button>
        <span id="mapControl" v-if="mapControlVisible">
            <button :class="randVisible ? 'buttonOn' : 'buttonOff'" @click="switchRandVisibility()">Rand</button>
        </span>
        <!-- Auskommentiert bis die Gefahrgutview funktioniert
        <GeHome class="geHome" v-show="gefahrgutHome" @gefahrnummerActive="openGeNumber" @unNummerActive="openGeUN" @eriActive="openGeERI" @klassenActive="openGeKlassen" @ghsActive="openGeGHS"/>
        <GeNumber v-if="gefahrgutNumber"/>
        <GeERI v-if="gefahrgutERI"/>
        <GeKlassen v-if="gefahrgutKlassen"/>
        <GeGHS v-if="gefahrgutGHS"/>
        <GeUN v-if="gefahrgutUN"/>
        -->
    </div>
    <Footer v-if="1==2" v-show="gefahrgutHome && randVisible" :backLink="gefahrgutHome?`/einsatz/`:`/gefahrgut/`"/>
    <div v-if="1==2" v-show="!gefahrgutHome" id="GefahrgutFooter">
        <!--<a id="HomeButton" :href="backLink+this.routeParams">
            <img src="@/assets/Icons/HomeButton.svg">
        </a>-->
        <a id="GefahrgutHomeButton" @click="openGeHome()">
          <img src="@/assets/Icons/HomeButton.svg">
        </a>
    </div>

    <!--<router-link :to="`/einsatz/`+this.$route.params.id"><button id="homeButton" class="mapButton"><img src="@/assets/Icons/HomeButton.svg"></button></router-link>-->
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import GeHome from '@/components/Gefahrgut/GeHome.vue'
import GeNumber from '@/components/Gefahrgut/GeNumber.vue'
import GeERI  from '@/components/Gefahrgut/GeERI.vue'
import GeKlassen from '@/components/Gefahrgut/GeKlassen.vue'
import GeGHS from '@/components/Gefahrgut/GeGHS.vue'
import GeUN from '@/components/Gefahrgut/GeUN.vue'
import Swal from 'sweetalert2';

export default {
    name: 'GefahrgutView',
    props:{
        
    },
    data() {
        return{
            gefahrgutHome: true,
            gefahrgutNumber: false,
            gefahrgutERI: false,
            gefahrgutKlassen: false,
            gefahrgutGHS: false,
            gefahrgutUN: false,
            mapControlVisible: false,
            randVisible: false,
        }
    },
    components: {
        Header,
        Footer,
        GeHome,
        GeNumber,
        GeERI,
        GeKlassen,
        GeGHS,
        GeUN
    },
    methods: {
        openGeHome: function(){
            this.gefahrgutNumber = false;
            this.gefahrgutHome = true;
            this.gefahrgutERI = false;
            this.gefahrgutKlassen = false;
            this.gefahrgutGHS = false;
            this.gefahrgutUN = false;
        },
        openGeNumber: function(){
            this.gefahrgutNumber = true;
            this.gefahrgutHome = false;
            this.gefahrgutERI = false;
            this.gefahrgutKlassen = false;
            this.gefahrgutGHS = false;
            this.gefahrgutUN = false;
        },
        openGeERI: function(){
            this.gefahrgutNumber = false;
            this.gefahrgutHome = false;
            this.gefahrgutERI = true;
            this.gefahrgutKlassen = false;
            this.gefahrgutGHS = false;
            this.gefahrgutUN = false;
        },
        openGeKlassen: function(){
            this.gefahrgutNumber = false;
            this.gefahrgutHome = false;
            this.gefahrgutERI = false;
            this.gefahrgutKlassen = true;
            this.gefahrgutGHS = false;
            this.gefahrgutUN = false;
        },
        openGeGHS: function(){
            this.gefahrgutNumber = false;
            this.gefahrgutHome = false;
            this.gefahrgutERI = false;
            this.gefahrgutKlassen = false;
            this.gefahrgutGHS = true;
            this.gefahrgutUN = false;
        },
        openGeUN: function(){
            this.gefahrgutNumber = false;
            this.gefahrgutHome = false;
            this.gefahrgutERI = false;
            this.gefahrgutKlassen = false;
            this.gefahrgutGHS = false;
            this.gefahrgutUN = true;
        },
        setup() {
            const emits = ['gefahrnummerActive', 'unNummerActive', 'eriActive', 'klassenActive', 'ghsActive', 'unActive'];
            return { emits };
        },
        switchMapControl() {
            this.mapControlVisible = !this.mapControlVisible;
        },
        switchRandVisibility() {
            this.randVisible = !this.randVisible;
        },
    },
    created(){
        /*Swal.fire(
            'Achtung!',
            'Daten können teilweise noch nicht korrekt sein. Anwendung noch im Bau',
            'warning'
        )*/
    }
}
</script>

<style lang="scss">
#gefahrgut{
    display: block !important;
    position:absolute !important;
    height:auto !important;
    bottom:0 !important;
    top:0 !important;
    left:0 !important;
    right:0 !important;
    button{
        background-color: white;
    }
    .geHome{
        margin-top: 4.1rem;
        position: absolute !important;
        bottom: auto;
        top: auto;
        right: 0;
        left: 0;
    }

    .iframe {
        width: 100vw;
        height: 89vh;
        background-color: white;
    }

    @media screen and (max-height: 768px) {
        iframe {
            height: 74vh !important;
            background-color: white;
            width: 100vw;
            height: 89vh;
            background-color: white;
        }
    }

    #controlButton {
        background-color: white !important;
        position: absolute !important;
        top: 15rem !important;
        right: 1.1rem !important;
        z-index: 1000 !important;
        padding: 0.5rem !important;
        border-radius: 7px !important;
    }

    #mapControl {
        background-color: white !important;
        position: absolute !important;
        top: 16.5rem !important;
        right: 2.6rem !important;
        z-index: 999 !important;
        padding: 1rem !important;
        border-radius: 7px !important;
        border: solid grey 1px;

        button {
            width: 100%;
            padding-top: 2px;
            padding-bottom: 2px;
            margin-top: 3px;
            margin-bottom: 3px;
            font-size: medium;
            padding-right: 3px;
            padding-left: 3px;
        }
    }
    .margin {
    display: block !important;
    position: absolute !important;
    height: auto !important;
    bottom: 0 !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
    //height: 72vh;
    }

    .noMargin {
    margin-top: 0rem !important;
    height: 100vh !important;
    }

    .fullscreen{
        width: 100vw !important;
        height: 100vh !important;
    }
}

    #GefahrgutFooter{
        background-color: #C00000;
        position: fixed;
        margin: 0;
        padding: 0;
        bottom: 0;
        height: 4.5rem;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        z-index: 10000;
    }

    #GefahrgutHomeButton{
        cursor: pointer;
        img{
            height: 3.6rem;
            background-color: none;
            cursor: pointer;
        }
    }

    #homeButton{
        position: absolute;
        //bottom: -2.7rem;
        bottom: 1.5rem;
        left: 50%;
        transform: translateX(-50%);
    }

    .mapButton{
        width: 3.5rem;
        height: 3.5rem;
        box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.11);
        background-color: white;
        z-index: 400;
        border: none;
        border-radius: 90px;
        transition: transform 0.3s ease;

        img{
            height: 60%;
            margin: auto;
        }
    }
</style>